import { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/navbar/Navbar";
import { TransaksiKeuangan as API } from "../../helpers";
import { Alert } from "flowbite-react";
import Login from "../Login";
import NotFound from "../errors/404NotFound";
import { Link } from "react-router-dom";
import {
  Card,
  Label,
  Select,
  Table,
  Spinner,
  Pagination,
  TextInput,
  Button,
  Modal,
} from "flowbite-react";
import Datepicker from "react-tailwindcss-datepicker";
import { DateHelper } from "../../helpers";

const allowedEmailTransaksiKeuangan =
  process.env.REACT_APP_ALLOWED_EMAIL_TRANSAKSI_KEUANGAN.split(",") || [];

const TransaksiKeuangan = () => {
  if (localStorage.getItem("authorized")) {
    const auth = JSON.parse(localStorage.getItem("kerjasama_bu"));

    return allowedEmailTransaksiKeuangan.includes(auth.email) ? (
      <TransaksiKeuanganPage />
    ) : (
      <NotFound />
    );
  } else {
    return <Login />;
  }
};

const TransaksiKeuanganPage = () => {
  const penerimas = {
    kpu_uso: "KPU / USO",
    kerjasama_bu: "Kerjasama Badan Usaha",
    pendapatan_lain_lain: "Pendapatan Lain-lain",
  };
  const banks = { bni: "BNI", bri: "BRI", btn: "BTN", mandiri: "Mandiri" };
  const status = { FAILED: "Failed", SENT: "Sent", PENDING: "Pending" };

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [tanggal, setTanggal] = useState({
    startDate: null,
    endDate: null,
  });

  const [selectedBank, setSelectedBank] = useState("");
  const [selectedPenerima, setSelectedPenerima] = useState("");
  const [selectedTanggal, setSelectedTanggal] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("FAILED");
  const [keyword, setKeyword] = useState("");
  const [filters, setFilters] = useState({});

  const [paymentLogs, setPaymentLogs] = useState([]);
  const [isFailedGetPaymentLogs, setIsFailedGetPaymentLogs] = useState(false);

  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [openModalRepost, setOpenModalRepost] = useState(false);
  const [openModalResult, setOpenModalResult] = useState(false);
  const [detailTransaksi, setDetailTransaksi] = useState({});

  const [resultRepost, setResultRepost] = useState({});
  const [isLoadingRepost, setIsLoadingRepost] = useState(false);
  const [isFailedRepost, setIsFailedRepost] = useState(false);

  const handleOnFilter = () => {
    setFilters({
      receiver: selectedPenerima,
      dates: selectedTanggal,
      bank: selectedBank,
      page: 1,
      status: selectedStatus,
    });
    setKeyword("");
    setPage(1);
    setIsLoading(true);
  };

  const handleOnSearch = (event) => {
    setKeyword(event.target.value);
    setTimeout(() => {
      setFilters({ ...filters, search: event.target.value, page: 1 });
      setPage(1);
      setIsLoading(true);
    }, 500);
  };

  const handleOnDatepicker = (dates) => {
    const startDate = dates.startDate?.toISOString().split("T")[0];
    const endDate = dates.endDate?.toISOString().split("T")[0];

    let arraySelectedDates = [];

    if (startDate && endDate) {
      arraySelectedDates =
        startDate === endDate ? [startDate] : [startDate, endDate];
    }

    setTanggal(dates);
    setSelectedTanggal(arraySelectedDates);
  };

  const selectPaymentLogs = (id) => {
    setDetailTransaksi(paymentLogs.find((paymentLog) => paymentLog.id === id));
  };

  const fetchData = useCallback(async () => {
    await API.logs(filters)
      .then((response) => {
        setIsLoading(false);

        if (response.status === 200) {
          setPage(response.data.page);
          setTotalPages(response.data.totalPages);
          setIsFailedGetPaymentLogs(false);
          setPaymentLogs(response.data.result);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setIsFailedGetPaymentLogs(true);
        setPaymentLogs([]);
      });
  }, [filters, page]);

  const sendRepost = async (id) => {
    await API.repost(id)
      .then((response) => {
        setResultRepost(response.data);
        setIsLoadingRepost(false);
        setIsFailedRepost(!response.status);
        setOpenModalRepost(false);
        setOpenModalResult(true);
      })
      .catch((error) => {
        setResultRepost(error.response.data);
        setIsLoadingRepost(false);
        setIsFailedRepost(true);
        setOpenModalRepost(false);
        setOpenModalResult(true);
      });
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div id="transaksi-keuangan" className="bg-gray-light">
      <div id="header">
        <Navbar appName={"Transaksi Keuangan"} url={"/transaksi-keuangan"} />
        <div className="flex items-center h-20 px-8 md:px-16">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-8 text-primary-main mr-2"
          >
            <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
            <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
          </svg>

          <Link
            to={"/"}
            className="w-full text-lg md:text-xl font-semibold py-2 text-gray-800"
          >
            Kembali ke Dashboard
          </Link>
        </div>
      </div>
      <div id="content" className="px-8 md:px-16">
        <Card className="w-full">
          <h5 className="text-xl font-bold tracking-tight text-gray-800">
            Log Data Transaksi Keuangan
          </h5>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <div className="mb-2 block">
                <Label htmlFor="tanggal" value="Filter Berdasarkan Tanggal" />
              </div>
              <Datepicker
                primaryColor={"cyan"}
                value={tanggal}
                i18n={"id"}
                startWeekOn="mon"
                readOnly={true}
                useRange={false}
                separator="sampai"
                popoverDirection="down"
                onChange={(newTanggal) => handleOnDatepicker(newTanggal)}
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="penerima" value="Filter Berdasarkan Penerima" />
              </div>
              <Select
                id="penerima"
                onChange={(event) => {
                  setSelectedPenerima(event.target.value);
                }}
              >
                <option value="">Semua Penerima</option>
                {Object.entries(penerimas).map(([key, value], i) => (
                  <option key={i} value={key}>
                    {value}
                  </option>
                ))}
              </Select>
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="bank" value="Filter Berdasarkan Bank" />
              </div>
              <Select
                id="bank"
                onChange={(event) => {
                  setSelectedBank(event.target.value);
                }}
              >
                <option value="">Semua Bank</option>
                {Object.entries(banks).map(([key, value], i) => (
                  <option key={i} value={key}>
                    {value}
                  </option>
                ))}
              </Select>
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="status" value="Filter Berdasarkan Status" />
              </div>
              <Select
                id="status"
                onChange={(event) => {
                  setSelectedStatus(event.target.value);
                }}
              >
                {Object.entries(status).map(([key, value], i) => (
                  <option key={i} value={key}>
                    {value}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className="flex flex-row md:flex-row-reverse mt-2">
            <button
              onClick={handleOnFilter}
              className="bg-primary-main hover:bg-primary-dark text-white p-2 font-semibold rounded-lg text-sm text-center px-5 py-3 duration-300"
            >
              Filter Data
            </button>
          </div>
        </Card>

        {isFailedGetPaymentLogs ? (
          <Alert color="failure" className="mt-8">
            <span className="font-medium">Gagal Memuat Data!</span> Silahkan
            coba kembali.
          </Alert>
        ) : null}

        <div className="flex flex-row-reverse mt-8">
          <div className="max-w-md">
            <TextInput
              id="search"
              placeholder="Cari Log Transaksi"
              shadow
              onChange={handleOnSearch}
              value={keyword}
            />
          </div>
        </div>

        <div className="overflow-x-auto mt-4">
          <Table striped>
            <Table.Head>
              <Table.HeadCell>Penerima</Table.HeadCell>
              <Table.HeadCell>Bank</Table.HeadCell>
              <Table.HeadCell>Nominal</Table.HeadCell>
              <Table.HeadCell>Posting Date</Table.HeadCell>
              <Table.HeadCell>Response Code</Table.HeadCell>
              <Table.HeadCell>Status</Table.HeadCell>
              <Table.HeadCell>Aksi</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {isLoading ? (
                <Table.Row>
                  <Table.Cell colSpan={7} className="text-center">
                    <Spinner aria-label="Memuat Data Log Transaksi" />
                  </Table.Cell>
                </Table.Row>
              ) : paymentLogs.length ? (
                paymentLogs.map((value, index) => {
                  return (
                    <Table.Row key={value?.id}>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        {penerimas[value?.appName]}
                      </Table.Cell>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        {value?.bank?.name}
                      </Table.Cell>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        {value?.data?.nominal
                          ? value?.data.nominal
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                          : null}
                      </Table.Cell>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        {DateHelper.convertFullDateIndonesia(
                          value?.data?.postingDate
                        )}
                      </Table.Cell>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        {value?.responseCode}{" "}
                        {parseInt(value?.responseCode) === 200
                          ? "(OK)"
                          : "(Failed)"}
                      </Table.Cell>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        {value?.status}
                      </Table.Cell>
                      <Table.Cell className="whitespace-nowrap font-medium text-gray-800">
                        <div className="flex flex-row gap-2">
                          <Button
                            size="xs"
                            onClick={() => {
                              selectPaymentLogs(value?.id);
                              setOpenModalDetail(true);
                            }}
                          >
                            Detail
                          </Button>
                          {value?.attempt >= 3 && value?.status === "FAILED" ? (
                            <Button
                              size="xs"
                              color="failure"
                              onClick={() => {
                                selectPaymentLogs(value?.id);
                                setOpenModalRepost(true);
                              }}
                            >
                              Repost
                            </Button>
                          ) : null}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  );
                })
              ) : (
                <Table.Row>
                  <Table.Cell
                    colSpan={7}
                    className="whitespace-nowrap font-medium text-gray-800 text-center"
                  >
                    Data Tidak Ditemukan
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>
        <div className="flex overflow-x-auto sm:justify-center">
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={(_page) => {
              setPage(_page);
              setFilters({ ...filters, page: _page });
              setIsLoading(true);
            }}
            showIcons
          />
        </div>
      </div>
      <div id="footer" className="pt-6">
        <footer className="px-8 md:px-16 py-10 bg-white text-secondary-dark font-semibold">
          <div className="container mx-auto">
            <div className="grid grid-cols-2">
              <div className="text-sm md:text-base">
                Copyright &copy; 2023 Divisi Pendapatan Direktorat Keuangan
                BAKTI Kominfo
              </div>
              <div className="text-sm md:text-base text-end">
                Develop by{" "}
                <a
                  href="https://reksa.co.id/"
                  className="underline font-medium"
                  target="_blank"
                  rel="noreferrer"
                >
                  Reksa Karya
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <Modal
        show={openModalDetail}
        size={"7xl"}
        onClose={() => setOpenModalDetail(false)}
      >
        <Modal.Header>Detail Data Transaksi</Modal.Header>
        <Modal.Body>
          <div className="flex flex-col space-y-6 p-6 divide-y-2">
            <div className="flex flex-col md:flex-row gap-6 md:divide-x-2">
              <div className="md:basis-2/5">
                <h5 className="text-lg font-bold tracking-tight text-gray-800">
                  Aplikasi Penerima
                </h5>
                <p className="text-sm font-semibold text-gray-500">
                  Menampilkan informasi tentang aplikasi penerima data
                </p>
              </div>
              <div className="md:basis-3/5">
                <div className="flex flex-col space-y-2">
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Nama Aplikasi</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">
                      {penerimas[detailTransaksi?.appName]}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Receiver URL</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">{detailTransaksi?.receiver}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-6 pt-6 md:divide-x-2">
              <div className="basis-2/5">
                <h5 className="text-lg font-bold tracking-tight text-gray-800">
                  Data Transaksi
                </h5>
                <p className="text-sm font-semibold text-gray-500">
                  Menampilkan informasi tentang detail data transaksi
                </p>
              </div>
              <div className="basis-3/5">
                <div className="flex flex-col space-y-2">
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Bank</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">
                      {detailTransaksi?.bank?.name}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Kode Transaksi</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">
                      {detailTransaksi?.data?.transactionCode}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Nominal</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">
                      {detailTransaksi?.data?.nominal
                        ? detailTransaksi?.data.nominal
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                        : null}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Tanggal Posting</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">
                      {DateHelper.convertFullDateIndonesia(
                        detailTransaksi?.data?.postingDate
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-6 pt-6 md:divide-x-2">
              <div className="basis-2/5">
                <h5 className="text-lg font-bold tracking-tight text-gray-800">
                  Response Data
                </h5>
                <p className="text-sm font-semibold text-gray-500">
                  Menampilkan informasi tentang response pengiriman data
                  transaksi dari aplikasi penerima
                </p>
              </div>
              <div className="basis-3/5">
                <div className="flex flex-col space-y-2">
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Status</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">{detailTransaksi?.status}</div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Message</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">
                      {JSON.stringify(detailTransaksi?.response)}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Pengiriman Ke</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">{detailTransaksi?.attempt}</div>
                  </div>
                  <div className="flex flex-row">
                    <div className="basis-5/12 md:pl-8">Waktu Pengiriman</div>
                    <div className="basis-1/12">:</div>
                    <div className="basis-4/6">{detailTransaksi?.sentAt}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        {detailTransaksi?.attempt >= 3 &&
        detailTransaksi?.status === "FAILED" ? (
          <Modal.Footer className="flex flex-row-reverse">
            <Button
              color="failure"
              onClick={() => {
                setOpenModalDetail(false);
                setOpenModalRepost(true);
              }}
            >
              Repost
            </Button>
          </Modal.Footer>
        ) : null}
      </Modal>
      <Modal
        show={openModalRepost}
        size="lg"
        onClose={() => setOpenModalRepost(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-red-700"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500">
              Repost Log Transaksi {penerimas[detailTransaksi?.appName]} dari{" "}
              {detailTransaksi?.bank?.name} pada tanggal{" "}
              {DateHelper.convertFullDateIndonesia(
                detailTransaksi?.data?.postingDate
              )}{" "}
              sebesar{" "}
              {detailTransaksi?.data?.nominal
                ? detailTransaksi?.data.nominal
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                : null}{" "}
              ?
            </h3>
            <div className="flex justify-center gap-4">
              <Button
                color="failure"
                onClick={() => {
                  setOpenModalRepost(false);
                  sendRepost(detailTransaksi?.id);
                }}
                disabled={isLoadingRepost}
                isProcessing={isLoadingRepost}
              >
                {"Repost"}
              </Button>
              <Button
                color="light"
                onClick={() => setOpenModalRepost(false)}
                disabled={isLoadingRepost}
              >
                Batalkan
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={openModalResult}
        size="lg"
        onClose={() => setOpenModalResult(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            {isFailedRepost ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="mx-auto mb-4 h-14 w-14 text-red-700"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="mx-auto mb-4 h-14 w-14 text-green-700"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            )}
            <h3 className="mb-3 text-xl font-semibold text-gray-700">
              {isFailedRepost ? "Repost Gagal!" : "Repost Berhasil!"}
            </h3>
            <h3 className="mb-5 text-lg font-normal text-gray-500">
              {isFailedRepost
                ? resultRepost?.message
                : "Repost berhasil dilakukan pada transaksi yang dipilih!"}
            </h3>
            {isFailedRepost && resultRepost?.data ? (
              <p className="mb-5 text-sm font-normal text-gray-500">
                {JSON.stringify(resultRepost?.data)}
              </p>
            ) : null}
            <div className="flex justify-center gap-4">
              <Button
                color={isFailedRepost ? "failure" : "success"}
                onClick={() => {
                  setOpenModalResult(false);
                }}
              >
                {"Tutup"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TransaksiKeuangan;
